import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFirefoxbrowserComponent } from './simple-icons-firefoxbrowser.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFirefoxbrowserComponent ],
    exports:      [ SimpleIconsFirefoxbrowserComponent ],
    bootstrap:    []
})
export class SimpleIconsFirefoxbrowserModule {}
